export default {
  VUMACORE: 'VUMACORE',
  VUMAREACH: 'VUMAREACH',
  VUMAKEY: 'VUMAKEY'
}
